module.exports = __webpack_public_path__ + "img/characterAnime10.6fca61df.png";